exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n\n.main-container{\n  margin-top: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/angular/16.angularformData Password1 = Password2/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Applications/MAMP/htdocs/angular/16.angularformData Password1 = Password2/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Applications/MAMP/htdocs/angular/16.angularformData Password1 = Password2/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/styles.css
// module chunks = styles